import { Map } from 'immutable'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { usePageElementPosition } from '../../../../hooks/useWidgetComponent'
import { StyleElement } from '../../../Main/StyleElement'
import { collectModalsID } from '../../../../lib/collectModalsID'
import { isSame } from '../isSame'

export const ElementPosition = ({ uid, PageID, isPreview }) => {
  const { position, vis, size } = usePageElementPosition(uid, PageID, isPreview)

  return `.ft--pos--${uid} {
        ${position}
    }
    .ft--vis--${uid} {
        ${vis}
    }${size ? size : ''}`.replace(/\r|\n|[\s]{2,}/g, '')
}

const ElementsPosition = ({ isPreview }) => {
  const ModalElementsID = useSelector(collectModalsID, shallowEqual)
  const elements = useSelector((state) => state.getIn(['project', 'Settings', 'elements'], Map()), isSame)
  return elements
    .map((_, uid) =>
      ModalElementsID.includes(uid) ? null : (
        <ElementPosition key={uid} uid={uid} PageID="project" isPreview={isPreview} />
      )
    )
    .toList()
}

export function ProjectElementsPositions({ isPreview }) {
  return (
    <StyleElement
      key="ft-project-position"
      uid="ft-project-position"
      styleEl={<ElementsPosition isPreview={isPreview} suppressHydrationWarning />}
    />
  )
}
